import React from 'react';
import { RouterProvider } from 'react-router/dom';

import './utils/fontAwesome';
import router from './routes/router';


const App = () => <RouterProvider router={router} />;

export default App;
